import { apiGatewayService } from './../apiService/HttpService';
import { setEndPoint } from './../apiService/SetEndPoint';
import { reportsEndPoints } from './../apiService/ReportsEndPoints';

class RegisteredUsersService {
  static getRegisteredUsersReport(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getReisteredUsersReport, ...extraParams),
      params,
    });
  }
}
export default RegisteredUsersService;
